module.exports = __webpack_public_path__ + "img/VERA.5437c059.jpeg";